/**
 * Shared hover-tracking context for graph edges.
 *
 * EvidenceBoard pushes the currently-hovered node id here via React Flow's
 * onNodeMouseEnter / onNodeMouseLeave. ResearchEdge reads it to decide
 * whether its label should light up — so hovering a conclusion makes
 * its incoming edge label pop, instead of every label competing at once.
 */

import { createContext } from 'react';

export const HoverContext = createContext<string | null>(null);
